import { fetchFromOldApi } from '~/services/Http';

import { IFormInput } from '../useWorkContact';
export interface Office {
  fOfficeId: number;
  fOfficeCity: string;
  fOfficeName: string;
}

export type EmpOffContactType = {
  fEmpEmailWork: string;
  fEmpOfficeFloor?: string;
  fEmpOfficeLoc: number;
  fEmpOfficeRoom?: string;
  fEmpPhoneMob?: string;
  fEmpPhoneWork?: string;
};

export const putEmpOffContactData = async (
  json: IFormInput,
  iEmpId: number,
) => {
  return await fetchFromOldApi('/form/employee/' + iEmpId + '/work', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(json),
  }).then((r) => r.json());
};

export const getCompanyOffices = (): Promise<Office[]> => {
  return fetchFromOldApi('/json/office?includeInactive=true').then((r) =>
    r.json(),
  );
};
